"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var rest_1 = __importDefault(require("../../rest"));
var invtiationsApi_1 = require("../mock/invtiationsApi");
var coreServiceUrl = process.env.CB_CORE_SERVICE_SERVER_URL;
var invitationsApi = {
    getPendingUsers: function (token, options) { return __awaiter(void 0, void 0, void 0, function () {
        var search, offset, limit, courses, teams, roles, invitedBy, dateInvitedTo, dateInvitedFrom, dateInvitedPresets, courseString, teamString, roleString, invitedByString, dateInvitedPresetsString, queryParams, params, url;
        return __generator(this, function (_a) {
            search = options.search, offset = options.offset, limit = options.limit, courses = options.courses, teams = options.teams, roles = options.roles, invitedBy = options.invitedBy, dateInvitedTo = options.dateInvitedTo, dateInvitedFrom = options.dateInvitedFrom, dateInvitedPresets = options.dateInvitedPresets;
            courseString = courses === null || courses === void 0 ? void 0 : courses.toString();
            teamString = teams === null || teams === void 0 ? void 0 : teams.toString();
            roleString = roles === null || roles === void 0 ? void 0 : roles.toString();
            invitedByString = invitedBy === null || invitedBy === void 0 ? void 0 : invitedBy.toString();
            dateInvitedPresetsString = dateInvitedPresets === null || dateInvitedPresets === void 0 ? void 0 : dateInvitedPresets.toString();
            queryParams = new URLSearchParams(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (search !== undefined && { search: search })), (offset !== undefined && { offset: String(offset) })), (limit !== undefined && { limit: String(limit) })), (courseString && { courses: courseString })), (teamString !== undefined && { teams: teamString })), (roles !== undefined && { roles: roleString })), (invitedBy !== undefined && { invitedBy: invitedByString })), (dateInvitedTo !== undefined && { dateInvitedTo: String(dateInvitedTo) })), (dateInvitedFrom !== undefined && { dateInvitedFrom: String(dateInvitedFrom) })), (dateInvitedPresetsString !== undefined && { dateInvitedPresets: dateInvitedPresetsString })));
            params = queryParams.toString();
            url = "".concat(coreServiceUrl, "/invitations/pending-users").concat(params ? "?".concat(params) : '');
            return [2 /*return*/, rest_1.default.get({
                    mockFunc: function () { return invtiationsApi_1.pendingUsersMock; },
                    url: url,
                    token: token,
                })];
        });
    }); },
    getDraftUsers: function (token, options) { return __awaiter(void 0, void 0, void 0, function () {
        var search, offset, limit, primaryCourses, teams, roles, uuids, errors, primaryCoursesString, teamString, roleString, uuidString, errorString, queryParams, params, url;
        return __generator(this, function (_a) {
            search = options.search, offset = options.offset, limit = options.limit, primaryCourses = options.primaryCourses, teams = options.teams, roles = options.roles, uuids = options.uuids, errors = options.errors;
            primaryCoursesString = primaryCourses === null || primaryCourses === void 0 ? void 0 : primaryCourses.toString();
            teamString = teams === null || teams === void 0 ? void 0 : teams.toString();
            roleString = roles === null || roles === void 0 ? void 0 : roles.toString();
            uuidString = uuids === null || uuids === void 0 ? void 0 : uuids.toString();
            errorString = errors === null || errors === void 0 ? void 0 : errors.toString();
            queryParams = new URLSearchParams(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (search !== undefined && { search: search })), (offset !== undefined && { offset: String(offset) })), (limit !== undefined && { limit: String(limit) })), (primaryCoursesString && { primaryCourses: primaryCoursesString })), (teamString !== undefined && { teams: teamString })), (roles !== undefined && { roles: roleString })), (uuidString !== undefined && { uuids: uuidString })), (errorString !== undefined && { errors: String(errorString) })));
            params = queryParams.toString();
            url = "".concat(coreServiceUrl, "/invitations/draft-users").concat(params ? "?".concat(params) : '');
            return [2 /*return*/, rest_1.default.get({
                    mockFunc: function () { return invtiationsApi_1.draftUsersMock; },
                    url: url,
                    token: token,
                })];
        });
    }); },
    createDraftUser: function (token, body) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, rest_1.default.post({
                    mockFunc: function () { return ({ success: true, uuid: '123' }); },
                    url: "".concat(coreServiceUrl, "/invitations/create-draft-user"),
                    body: body,
                    token: token,
                })];
        });
    }); },
    updateDraftUser: function (token, body) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, rest_1.default.post({
                    mockFunc: function () { return ({ success: true }); },
                    url: "".concat(coreServiceUrl, "/invitations/update-draft-user"),
                    body: body,
                    token: token,
                })];
        });
    }); },
    deleteDraftUsers: function (token, body) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, rest_1.default.delete({
                    mockFunc: function () { return ({ success: true }); },
                    url: "".concat(coreServiceUrl, "/invitations/draft-users"),
                    body: body,
                    token: token,
                })];
        });
    }); },
    uploadCsv: function (token, file) { return __awaiter(void 0, void 0, void 0, function () {
        var formData, response, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    formData = new FormData();
                    formData.append('users', file);
                    return [4 /*yield*/, fetch("".concat(coreServiceUrl, "/invitations/upload-csv"), {
                            method: 'POST',
                            body: formData,
                            headers: {
                                Authorization: token,
                            },
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    return [2 /*return*/, data];
            }
        });
    }); },
    updateBulkCourseDraftUser: function (token, body) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, rest_1.default.put({
                    mockFunc: function () { return ({ success: true }); },
                    url: "".concat(coreServiceUrl, "/invitations/primary-courses"),
                    body: body,
                    token: token,
                })];
        });
    }); },
    updateBulkTeamDraftUser: function (token, body) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, rest_1.default.post({
                    mockFunc: function () { return ({ success: true }); },
                    url: "".concat(coreServiceUrl, "/invitations/draft-teams"),
                    body: body,
                    token: token,
                })];
        });
    }); },
    updateSingleTeamDraftUser: function (token, body, currentTeamName) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, rest_1.default.post({
                    mockFunc: function () { return ({ success: true }); },
                    url: "".concat(coreServiceUrl, "/invitations/draft-teams/").concat(currentTeamName),
                    body: body,
                    token: token,
                })];
        });
    }); },
    deleteSingleTeamDraftUser: function (token, currentTeamName) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, rest_1.default.delete({
                    mockFunc: function () { return ({ success: true }); },
                    url: "".concat(coreServiceUrl, "/invitations/draft-teams/").concat(currentTeamName),
                    token: token,
                })];
        });
    }); },
    getLicenseDetails: function (token) { return __awaiter(void 0, void 0, void 0, function () {
        var url;
        return __generator(this, function (_a) {
            url = "".concat(coreServiceUrl, "/invitations/license-data");
            return [2 /*return*/, rest_1.default.get({
                    mockFunc: function () { return invtiationsApi_1.licenseMock; },
                    url: url,
                    token: token,
                })];
        });
    }); },
    sendUsersInvitation: function (token) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, rest_1.default.post({
                    mockFunc: function () { return ({ success: true, jobId: 1 }); },
                    url: "".concat(coreServiceUrl, "/invitations/perform-invitation"),
                    token: token,
                })];
        });
    }); },
    getInvitationSummary: function (token) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, rest_1.default.get({
                    mockFunc: function () { return invtiationsApi_1.invitationSummaryMock; },
                    url: "".concat(coreServiceUrl, "/invitations/summary"),
                    token: token,
                })];
        });
    }); },
    deletePendingUsers: function (token, body) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, rest_1.default.delete({
                    mockFunc: function () { return ({ success: true }); },
                    url: "".concat(coreServiceUrl, "/invitations/pending-users"),
                    body: body,
                    token: token,
                })];
        });
    }); },
    resendInvite: function (token, body) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, rest_1.default.post({
                    mockFunc: function () { return ({ success: true }); },
                    url: "".concat(coreServiceUrl, "/invitations/resend"),
                    body: body,
                    token: token,
                })];
        });
    }); },
    getUploadInvitationEmailLogoUrl: function (token, fileName) {
        return rest_1.default.get({
            mockFunc: function () { return invtiationsApi_1.mockInvitationEmailLogoUrl; },
            url: "".concat(coreServiceUrl, "/invitations/upload-email-logo?filename=").concat(fileName),
            token: token,
        });
    },
    uploadImage: function (signedUrl, imageFile, type) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, fetch(signedUrl, {
                    method: 'PUT',
                    body: new Blob([imageFile], { type: type }),
                })];
        });
    }); },
};
exports.default = invitationsApi;
